export default "__VITE_ASSET__CiW5qAXO__"